:host {
  --ch-smart-grid-smart-cell-reserved-space-size: 0px;
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
}

:host(.ch-smart-grid--loaded-render-delay) {
  opacity: 0;
  pointer-events: none;
}

:host(.ch-smart-grid--inverse-loading) {
  grid-template-rows: max-content 1fr;
}

:host(.ch-smart-grid--data-provider) {
  grid-template-rows: 1fr max-content;
}

:host(.ch-scrollable) {
  contain: strict;
  overflow: auto;
  overflow-anchor: none;
}

::slotted([slot=grid-content]) {
  display: grid;
  grid-auto-rows: max-content;
}